import { render } from "./SpamNumberDetailPage.vue?vue&type=template&id=0ff2aa8e&ts=true"
import script from "./SpamNumberDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpamNumberDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/spam-number/SpamNumberDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ff2aa8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ff2aa8e', __exports__)) {
    api.reload('0ff2aa8e', __exports__)
  }
  
  module.hot.accept("./SpamNumberDetailPage.vue?vue&type=template&id=0ff2aa8e&ts=true", () => {
    api.rerender('0ff2aa8e', render)
  })

}


export default __exports__